export default __webpack_public_path__ + "static/media/empty-state-list.204b266a.svg";